// No automatic delivery is claimed: visitors explicitly send this draft in their email app.
export function enquiryDraft({name,email,subject='New Contact Form Submission',message,phone=''}:{name:string;email:string;subject?:string;message:string;phone?:string}) {
  const body=`Name: ${name.trim()}\nEmail: ${email.trim()}${phone ? '\nPhone: '+phone.trim() : ''}\n\n${message.trim()}`;
  return `mailto:info@renaissancegardenschools.com?subject=${encodeURIComponent(subject.trim())}&body=${encodeURIComponent(body)}`;
}
